import Skeleton from "@mui/material/Skeleton";
import { styled } from "@mui/material/styles";

import { Wrapper, TitleWrapper } from "./ProductHeaderLayoutComponents";
import { ProductHeaderSection, HeaderSectionProps } from "./ProductHeaderSection";

export function ProductHeaderSkeleton(props: Omit<HeaderSectionProps, "title" | "ProductHeaderComponent">) {
    const { withStickyAppBar, showHeader } = props;

    return (
        <ProductHeaderSection
            title=""
            showHeader={showHeader}
            withStickyAppBar={withStickyAppBar}
            ProductHeaderComponent={ProductHeaderComponentSkeleton}
        />
    );
}

function ProductHeaderComponentSkeleton() {
    return (
        <Wrapper>
            <TitleWrapper>
                <Skeleton variant="rectangular" width="80%" height={42} />
            </TitleWrapper>
            <Price>
                <Skeleton variant="rectangular" width={72} height={42} />
            </Price>
        </Wrapper>
    );
}

const Price = styled("div")(({ theme }) => ({
    gridArea: "price",
    alignSelf: "end",
    [theme.breakpoints.down("lg")]: {
        alignSelf: "start",
    },
}));
